module.exports = __webpack_public_path__ + "static/media/nav.7ab14357.svg";